/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getRightmoveFee = /* GraphQL */ `
  query GetRightmoveFee($id: ID!) {
    getRightmoveFee(id: $id) {
      id
      feeType
      startDate
      endDate
      amount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listRightmoveFees = /* GraphQL */ `
  query ListRightmoveFees(
    $filter: ModelRightmoveFeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRightmoveFees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        feeType
        startDate
        endDate
        amount
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getForecast = /* GraphQL */ `
  query GetForecast($id: ID!) {
    getForecast(id: $id) {
      id
      feeType
      startDate
      endDate
      amount
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listForecasts = /* GraphQL */ `
  query ListForecasts(
    $filter: ModelForecastFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listForecasts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        feeType
        startDate
        endDate
        amount
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
